/**
 * @Author: v_jppjpeng
 * @Date: 2023-05-23 19:50:02
 * @Explain: 登录、注册、忘记密码
 */

export default {
  // 登录公告
  'ADMIN.ANNOUNCEMENT.TITLE': 'Announcement',
  'ADMIN.ANNOUNCEMENT.TIPS1':
    'User data storage location will change to GCP Germany.',
  'ADMIN.ANNOUNCEMENT.TIPS2':
    'User data migration is scheduled for and expected to be completed in March 2024. User data will be migrated from Tencent Cloud Singapore to Google Cloud Platform Germany. ',
  'ADMIN.ANNOUNCEMENT.TIPS3': 'The updated Privacy Policy can be found below.',
  'ADMIN.ANNOUNCEMENT.TIPS4':
    'If you do not agree to the processing of your personal information in the way the Privacy Policy describes, please stop using SmartLink.',
  'ADMIN.ANNOUNCEMENT.TIPS5':
    'By continuing to use SmartLink, you are acknowledging our rules regarding your personal information as described in this Privacy Policy.',
  'ADMIN.ANNOUNCEMENT.PRIVACY.POLICY': 'Privacy Policy',
  'ADMIN.ANNOUNCEMENT.PRIVACY.POLICY.LAST.UPDATED':
    'Last updated: 22 February 2024',
  'ADMIN.ANNOUNCEMENT.OK': 'Ok',

  // 登录
  'ADMIN.LOGIN.TITLE': 'Log in to SmartLink',
  'ADMIN.LOGIN.NEED.ACCOUNT': 'Need a SmartLink account?',
  'ADMIN.LOGIN.CREATE.ACCOUNT': 'Create an account',
  'ADMIN.LOGIN.USERNAME.EMAIL': 'Username or Email',
  'ADMIN.LOGIN.PLEASE.ENTER.USERNAME.EMAIL': 'Enter your username or email',
  'ADMIN.LOGIN.PASSWORD': 'Password',
  'ADMIN.LOGIN.PASSWORD.CHECK1': 'Contains at least one lowercase letter',
  'ADMIN.LOGIN.PASSWORD.CHECK2': 'Contains at least one uppercase letter',
  'ADMIN.LOGIN.PASSWORD.CHECK3': 'Contains at least one number',
  'ADMIN.LOGIN.PASSWORD.CHECK4': 'Contains at least one special character',
  'ADMIN.LOGIN.PASSWORD.CHECK5': 'Minimum of 8 characters',
  'ADMIN.LOGIN.PLEASE.ENTER.PASSWORD': 'Enter your password',

  'ADMIN.LOGIN.NOT.EMAIL.PASSWORD': 'Username or password cannot be empty',
  'ADMIN.LOGIN.PLEASE.ENTER.PASSWORD.REG':
    'Enter a password that is at least 8 characters long and is a combination of uppercase letters, lowercase letters, numbers, and special characters.',
  'ADMIN.LOGIN.RE.PASSWORD': 'Confirm password',
  'ADMIN.LOGIN.PASSWORD.INCONSISTENCY':
    'Passwords do not match. Please Try again.',
  'ADMIN.LOGIN.PLEASE.CHECK.VERIFICATION.CODE':
    'Please check the verification code',
  'ADMIN.LOGIN.GET.SIGN.FAIL': 'Signature retrieval error',
  'ADMIN.LOGIN.FORGOT.PASSWORD': 'Forgot password?',
  'ADMIN.LOGIN.BTN': 'Log in',
  'ADMIN.LOGIN.OR': 'or',
  'ADMIN.LOGIN.IOA.BTN': 'Log in with Tencent OA account',
  'ADMIN.LOGIN.SUCCESS': 'Login successful',
  'ADMIN.LOGIN.FAIL.TRY': 'Login failed. Please refresh the page and try again',

  // 登录 - 长时间未操作形态
  'ADMIN.LOGIN.SESSION.TITLE': 'Your Session Has Expired',
  'ADMIN.LOGIN.SESSION.SMALL':
    'Enter your password to pick up where you left off.',
  'ADMIN.LOGIN.RESUME.SESSION': 'Resume session',
  'ADMIN.LOGIN.SESSION.PASSWORD.ERROR.TIPS1':
    'Sorry, that password is incorrect. We can help you',
  'ADMIN.LOGIN.SESSION.PASSWORD.ERROR.TIPS2': 'recover your password.',

  // 注册
  'ADMIN.REGISTER.TITLE': 'Sign up for SmartLink',
  'ADMIN.REGISTER.CREATE.ACCOUNT':
    '<span class="mr-5">Create a SmartLink account with your email or</span>',
  'ADMIN.REGISTER.CREATE.TIPS1': '1. Verify your email',
  'ADMIN.REGISTER.CREATE.TIPS2': '2. Set your username and password',
  'ADMIN.REGISTER.EMAIL': 'Email',
  'ADMIN.REGISTER.EMAIL.DEFAULT.MESSAGE':
    'Create a SmartLink account with your email',
  'ADMIN.REGISTER.PLEASE.ENTER.EMAIL': 'Enter your email',
  'ADMIN.REGISTER.PLEASE.ENTER.EMAIL.REG': 'Please enter a valid email address',
  'ADMIN.REGISTER.VERIFICATION.CODE': 'Verification code',
  'ADMIN.REGISTER.PLEASE.ENTER.VERIFICATION.CODE':
    'Enter the verification code',
  'ADMIN.REGISTER.PLEASE.ENTER.PASSWORD.REG': 'Password is incorrect',
  'ADMIN.REGISTER.SUCCESS': 'Registration successful',
  'ADMIN.REGISTER.USER.NAME': 'Username',
  'ADMIN.REGISTER.PLEASE.ENTER.USER.NAME': 'Enter your username',
  'ADMIN.REGISTER.PLEASE.ENTER.USER.NAME.REG':
    'You can use letters, numbers and special characters, but spaces cannot be used. Your username is case sensitive and cannot exceed 100 characters.',
  'ADMIN.REGISTER.ENTER.USER.NAME.ALREADY.EXIST':
    'This username already exists',
  'ADMIN.REGISTER.AGREEMENT.SELECT':
    'Please tick all boxes to indicate your consent',
  'ADMIN.REGISTER.AGREEMENT.TIPS1':
    'I consent to the transfer of my data outside of my country/region.',
  'ADMIN.REGISTER.AGREEMENT.TIPS2':
    'SmartLink is a product offered by Proxima Beta Pte. Limited, a Singapore incorporated company that will process your data outside of your country/region for the purposes set out in our <a href="{ppLink}" target="_blank">Privacy Policy</a>. Please note that there are risks in such a transfer, such as your data being subject to different legal regimes which may offer a different level of data protection as in the country/region you are located. You may revoke your consent by contacting us at <a href="mailto:{email}">{email}</a>.',
  'ADMIN.REGISTER.AGREEMENT.TIPS3':
    'I confirm that I have read, consent and agree to the <a href="{ppLink}" target="_blank">Privacy Policy</a>, the <a href="{dpaLink}" target="_blank">Data Processing Agreement</a> and <a href="{staLink}" target="_blank">SmartLink\'s Terms and Conditions</a>.',

  // 忘记密码
  'ADMIN.FORGOT.PW.TITLE': 'Reset your password',
  'ADMIN.FORGOT.PW.CREATE.TIPS1': '1. Verify your email',
  'ADMIN.FORGOT.PW.CREATE.TIPS2': '2. Set your new password',
  'ADMIN.FORGOT.PW.EMAIL': 'Email',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.EMAIL': 'Enter your email',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.EMAIL.REG':
    'Please enter a valid email address',
  'ADMIN.FORGOT.PW.VERIFICATION.CODE': 'Verification code',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.VERIFICATION.CODE':
    'Enter the verification code',
  'ADMIN.FORGOT.PW.NEW.PASSWORD': 'New password',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.NEW.PASSWORD': 'Enter your new password',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.NEW.PASSWORD.REG':
    'Enter the correct password format',
  'ADMIN.FORGOT.PW.RE.NEW.PASSWORD': 'Enter your new password again',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.RE.NEW.PASSWORD':
    'Please enter your new password again',
  'ADMIN.FORGOT.PW.DIFFERENT': 'Passwords do not match',
  'ADMIN.FORGOT.PW.SUCCESS.TIPS':
    'You have <span class="color-primary">successfully</span> reset your password',
  'ADMIN.FORGOT.PW.SUCCESS.BTN': 'Log in with your new password',

  // 弹窗 - 邀请加入项目
  'ADMIN.INVITE.JOIN.PROJECT.TITLE':
    'You have been invited to join a SmartLink project',
  'ADMIN.INVITE.JOIN.PROJECT.SMALL':
    '<b>{inviter}</b> has invited you to join project <div class="tag">{projectName}</div> as a role of <div class="tag">{roleName}</div>',
  'ADMIN.INVITE.JOIN.PROJECT.ROLE.TITLE': 'Description of roles in SmartLink',
  'ADMIN.INVITE.JOIN.PROJECT.YOU': 'Your role',
  'ADMIN.INVITE.JOIN.PROJECT.BTN': 'Join the project',
  'ADMIN.INVITE.JOIN.PROJECT.SUCCESS': 'Joined project successfully',

  'ADMIN.CHOOSE.PROJECT.TITLE': 'Choose a method for entering the project',
  'ADMIN.JOIN.PROJECT.TITLE': 'Join an existing project',
  'ADMIN.JOIN.PROJECT.DESC':
    'Your business partner will first need to create a project in SmartLink. Afterwards, ask the project owner or admin of the project to invite you by email to join this project.',
  'ADMIN.CREATE.PROJECT.TITLE': 'Create a new project',
  'ADMIN.CREATE.PROJECT.DESC':
    'As an owner, you can create new projects and invite others to this project in SmartLink.',
  'ADMIN.DEMO.PROJECT.TITLE': 'Try the demo',
  'ADMIN.DEMO.PROJECT.DESC':
    'You can explore most of the features of SmartLink in the demo project, before deciding on creating your own project.',

  // 欢迎页 - 进入demo提示
  'ADMIN.DEMO.PROJECT.MODAL.TITLE': 'Notice for Demo Project',
  'ADMIN.DEMO.PROJECT.MODAL.TIPS1':
    "The demo project allows you to explore SmartLink's features. Modifying data, such as saving new data or deleting existing data, is currently not supported in the demo project.",
  'ADMIN.DEMO.PROJECT.MODAL.TIPS2':
    "All data in the demo project is fabricated, which means that it's not possible to send emails to the contacts provided.",
  'ADMIN.DEMO.PROJECT.MODAL.BTN': 'Got it',

  // 欢迎页 - 邀请加入项目
  'ADMIN.WELCOME.HELLO': 'Hello, {accountName}',
  'ADMIN.WELCOME.SPEECH':
    'You have successfully created your <span class="color-primary">SmartLink account</span>!',

  //   无权限页面
  'ADMIN.NO.AUTH.TITLE': 'No permission',
  'ADMIN.NO.AUTH.CONTENT.1':
    "You have not selected a project. Please go to '<span class='mark'>My Projects</span>' and select a project to enter.",
  'ADMIN.NO.AUTH.CONTENT.2':
    'If you need project access, contact the Project Administrator to join a project or create a new one.',
  'ADMIN.NO.AUTH.CREATE.PROJECT': 'Create projects',
  'ADMIN.NO.AUTH.OWN.PROJECT': 'My projects',
  'ADMIN.NO.AUTH.UPDATE.ROLE':
    'If you need project access, <br/> please contact your project administrator to update your role.',
};
